import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d46334f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "onboarding-content" }
const _hoisted_2 = {
  key: 0,
  class: "top-bar"
}
const _hoisted_3 = { class: "top" }
const _hoisted_4 = { class: "image-container" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 0,
  class: "text-container"
}
const _hoisted_7 = {
  key: 1,
  class: "slider"
}
const _hoisted_8 = { class: "slider-content" }
const _hoisted_9 = { class: "buttons" }

import GenericButton from "@/components/buttons/GenericButton.vue";
import {
  OnboardingContainerTypeEnum,
  OnboardingProvideObject,
  OnboardingRouteItem,
  OnboardingRouteItemNameEnum,
} from "@/types/onboarding";

import { BridgeStatusEnum } from "@/types/webview";
import { GetterTypes } from "@/store";
import { onboardingInjectionKey } from "@/utils/onboarding/onboardingInjectionKey";
import { computed, inject } from "vue";
import { useRouter } from "vue-router";
import { useComputedValue } from "@/composables/useComputedValue";
import { ButtonObject, GenericButtonVariantEnum } from "@/types/button";
import { IconType } from "@/types/icons";
import Icon from "@/components/icons/Icon/Icon.vue";

interface Props {
  title: string;
  text: string;
  primaryButton?: ButtonObject;
  secondaryButton?: ButtonObject;
  imageName: string;
  componentName: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingContainer',
  props: {
    title: { default: "" },
    text: { default: "" },
    primaryButton: { default: undefined },
    secondaryButton: { default: undefined },
    imageName: { default: "" },
    componentName: { default: "" }
  },
  setup(__props: any) {

const injected = inject<OnboardingProvideObject>(onboardingInjectionKey, {
  type: OnboardingContainerTypeEnum.Settings,
  routeName: OnboardingRouteItemNameEnum.Welcome,
});

const router = useRouter();
const onboardingRoutes = useComputedValue<readonly OnboardingRouteItem[]>(
  GetterTypes.GET_ONBOARDING_ROUTES,
);

const currentIndex = onboardingRoutes.value.findIndex(
  (item) => item.name === injected.routeName,
);

const props = __props;

const contactsStatus = useComputedValue<BridgeStatusEnum>(
  GetterTypes.GET_PHONE_CONTACTS_STATUS,
);
const notificationsStatus = useComputedValue<BridgeStatusEnum>(
  GetterTypes.GET_NOTIFICATIONS_STATUS,
);

const imageSrc = computed<string>(() => {
  return `/images/${props.imageName}`;
});
const isSettings = computed<boolean>(() => {
  return injected.type === OnboardingContainerTypeEnum.Settings;
});
const isOnboarding = computed<boolean>(() => {
  return injected.type === OnboardingContainerTypeEnum.Onboarding;
});
const isBadgeShown = computed<boolean>(() => {
  return (
    isSettings.value &&
    currentStatus.value &&
    currentStatus.value !== BridgeStatusEnum.Unused
  );
});
const currentStatus = computed<BridgeStatusEnum>(() => {
  if (props.componentName.includes("phoneTransfer")) {
    return contactsStatus.value;
  }

  return notificationsStatus.value;
});

const appliedBadgeName = computed<IconType>(() => {
  return IconType[
    `BADGE_${currentStatus.value.toUpperCase()}` as keyof typeof IconType
  ];
});

const handleRedirectBack = () => {
  router.back();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["onboarding-container", _unref(injected).type])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!isOnboarding.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(Icon, {
              icon: _unref(IconType).BACK_CIRCLE,
              class: "icon",
              onClick: handleRedirectBack
            }, null, 8, ["icon"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: imageSrc.value,
            alt: imageSrc.value
          }, null, 8, _hoisted_5),
          (isBadgeShown.value)
            ? (_openBlock(), _createBlock(Icon, {
                key: 0,
                icon: appliedBadgeName.value,
                alt: appliedBadgeName.value,
                class: "img-success"
              }, null, 8, ["icon", "alt"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.title && _ctx.text)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t(_ctx.title)), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t(_ctx.text)), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      (isOnboarding.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(onboardingRoutes), (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.name,
                  class: _normalizeClass(["slider-item", { 'is-current': i === _unref(currentIndex) }])
                }, null, 2))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(GenericButton, {
        variant: _unref(GenericButtonVariantEnum).Primary,
        text: _ctx.primaryButton?.text,
        "on-click": _ctx.primaryButton?.handleClick
      }, null, 8, ["variant", "text", "on-click"]),
      (_ctx.secondaryButton && !isSettings.value)
        ? (_openBlock(), _createBlock(GenericButton, {
            key: 0,
            variant: _unref(GenericButtonVariantEnum).Terciary,
            text: _ctx.secondaryButton.text,
            "on-click": _ctx.secondaryButton.handleClick
          }, null, 8, ["variant", "text", "on-click"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})